import { useState } from "react";
import configServ from "../../services/config";

const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB per chunk

export default function ChunkedUpload() {
  const [progress, setProgress] = useState(0);

  const uploadFile = async (file) => {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const uploadId = `${Date.now()}-${file.name}`; // unique session ID

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append("chunk", chunk);
      formData.append("chunkIndex", chunkIndex);
      formData.append("totalChunks", totalChunks);
      formData.append("uploadId", uploadId);
      formData.append("fileName", file.name);

      const response = await fetch("http://localhost:8000/api/upload-chunk", {
        method: "POST",
        body: formData,
        cache: "no-store", // optional
      });

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json();

      if (data.success === false) {
        throw new Error(data.message || "Upload failed");
      }

      console.log(`Chunk ${chunkIndex + 1} uploaded`);

      setProgress(Math.round(((chunkIndex + 1) / totalChunks) * 100));
    }

    alert("Upload complete!");
  };

  return (
    <div>
      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => uploadFile(e.target.files[0])}
      />
      <p>Progress: {progress}%</p>
    </div>
  );
}
